
import AdminTransact from "../components/admin/AdminUserInvoice";

export default function AdminUserInvoice() {
  return (
    <div>
      <AdminTransact />
    </div>
  );
}
